<template>
    <div class="school-data-wrap">
  <div v-if="recommendData.data">
    <div
      class="school-info"
      v-for="(item, index) in recommendData.data.list"
      :key="index"
    >
      <div class="info-logo">
        <router-link
          tag="a"
          target="_blank"
          v-if="type==='1'"
          :to="{
              path: '/main/schoolDetail',
              query: { gbdm: item.gbdm, zyz: item.zyz,pc:item.pc,yxmc:item.yxmc,yxxh:item.yxxh }
          }"
        >
          <img :src="imgBaseUrl+item.gbdm+'.jpg'" :alt="item.yxmc" width="100%" height="100%" />
        </router-link>
        <router-link
          tag="a"
          target="_blank"
          v-if="type==='2'"
          :to="{
              path: '/main/zyzDetail',
              query: { gbdm: item.gbdm, zyz: item.zyz,pc:item.pc,yxmc:item.yxmc,yxxh:item.yxxh }
          }"
        >
          <img :src="imgBaseUrl+item.gbdm+'.jpg'" :alt="item.yxmc" width="100%" height="100%" />
        </router-link>
      </div>
      <div class="info-introduce">
        <div class="school-name">
          <router-link
            tag="a"
            target="_blank"
            v-if="type==='1'"
            :to="{
              path: '/main/schoolDetail',
              query: { gbdm: item.gbdm, zyz: item.zyz,pc:item.pc,yxmc:item.yxmc,yxxh:item.yxxh }
            }"
          >
            <h3>{{ item.yxmc }}
                <span v-if="type==='2'">[{{ item.zyz }}]专业组</span>
                <img src="../assets/images/ico2.png" alt="985" title="985" v-if="item.sf985&&item.sf985===1">
                <img src="../assets/images/ico1.png" alt="211" title="211" v-if="item.sf211&&item.sf211===1">
                <img src="../assets/images/ico8.png" alt="双一流" title="双一流" v-if="item.sfsyl&&item.sfsyl===1">
                <img src="../assets/images/ico9.png" alt="101" title="101" v-if="item.sf101&&item.sf101===1">
                <img src="../assets/images/ico3.png" alt="研究生院" title="研究生院" v-if="item.yfyjsy&&item.yfyjsy===1">
             </h3>
          </router-link>
          <router-link
            tag="a"
            target="_blank"
            v-if="type==='2'"
            :to="{
              path: '/main/zyzDetail',
              query: { gbdm: item.gbdm, zyz: item.zyz,pc:item.pc,yxmc:item.yxmc,yxxh:item.yxxh }
            }"
          >
            <h3>{{ item.yxmc }}
                <span v-if="type==='2'" style="margin-right:10px;">[{{ item.zyz }}]专业组</span>
                <img src="../assets/images/ico2.png" alt="985" title="985" v-if="item.sf985&&item.sf985===1">
                <img src="../assets/images/ico1.png" alt="211" title="211" v-if="item.sf211&&item.sf211===1">
                <img src="../assets/images/ico8.png" alt="双一流" title="双一流" v-if="item.sfsyl&&item.sfsyl===1">
                <img src="../assets/images/ico9.png" alt="101" title="101" v-if="item.sf101&&item.sf101===1">
                <img src="../assets/images/ico3.png" alt="研究生院" title="研究生院" v-if="item.yfyjsy&&item.yfyjsy===1">
             </h3>
          </router-link>
        </div>
        <div class="school-category">
          <div class="category-wrap">
            <div class="category-item" style="width:320px;margin-top: 10px;font-size:16px;">
              <span style="font-size: 16px;color: #ee5e45;">院校相关信息：</span>
              <span v-if="item.pc&&item.pc===6"><span style="color:blue">往年</span>本科批</span>
              <span v-if="item.pc&&item.pc===7"><span style="color:blue">往年</span>专科批</span>
            </div>
            <div class="category-item">院校代号：{{item.sb===''||item.sb===null?'':item.sb}}</div>
            <div class="category-item">录取概率：<span style="color:#f00">{{item.lqgl===''||item.lqgl===null?'':item.lqgl}}%</span></div>
              <el-tooltip placement="top">
                 <div slot="content">
                  {{item.ls===''||item.ls===null?'':item.ls}}
                </div>
                <div class="category-item">隶属：{{item.ls===''||item.ls===null?'':item.ls}}</div>
              </el-tooltip>
            <div class="category-item">硕士点：{{item.ssdgs===''||item.ssdgs===null?'':item.ssdgs}}</div>
            <div class="category-item">院校类型：{{item.xxlbmc===''||item.xxlbmc===null?'':item.xxlbmc}}</div>
            <div class="category-item">博士点：{{item.bsdgs===''||item.bsdgs===null?'':item.bsdgs}}</div>
            <div class="category-item">
              <div>
                <!--  -->
            <a :comp_id="item.yxxh" :comp_yxmc="item.yxmc" :comp_logo="imgBaseUrl+item.gbdm+'.jpg'" :comp_pc="item.pc"
              href="javascript:;" @click="yxdbClick($event,item,index,1)" v-if="currentArr.indexOf(index)<0"
              class="btnBt" style="margin-top:2px !important;border: 1px solid #09F;">
              加入院校对比</a>
            <a :comp_id="item.yxxh" :comp_yxmc="item.yxmc" :comp_logo="imgBaseUrl+item.gbdm+'.jpg'" :comp_pc="item.pc"
              href="javascript:;" @click="yxdbClick($event,item,index,2)"  v-if="currentArr.indexOf(index)>=0"
              class="btnBt" style="margin-top:2px !important;border: 1px solid #09F;" :class="{'current':(currentArr.indexOf(index)>=0)}">
              取消院校对比</a>
          </div>
            </div>
            <!-- <div class="category-item" v-if="type==='2'">
              <el-button type="primary" size="medium" @click="openTianBaoList">查看填报情况</el-button>
            </div> -->
          </div>
          <div class="info-data-wrap">
            <table class="info-data" style="margin-top: 28px;">
              <tr>
                <th colspan="12" v-if="type==='1'">{{item.yxmc}}数据</th>
                <th colspan="13" v-if="type==='2'">专业组{{item.zyz}}数据</th>
              </tr>
              <tr>
                <th rowspan="2">年度</th>
                <th colspan="6">录取分</th>
                <el-tooltip placement="top">
                  <div slot="content" style="width:400px;">
                    等效分就是今年的分数相当于往年的多少分数，它使得不同年分的分数能直接进行对比分析。
                    比如说2015理科100名是628分，等效于2014年理科100名的623分、2013年理科100名的588分，就是说按照试题难度系数、考生分数分布情况等，如果2015理科100名是628分的成绩，那放在2014年的高考中相当于考了623分，要是在2013年比较难的情况下，那相当于是考了588分。
                    等效分是基于考生成绩分布情况，系统通过科学的数学模型自动换算得来的。
                    具体到使用时，比如某学校14年在湖南的投档线是623分，入档位次是100名，那么15年就需要628分才能入档，由于一分段表在一个分数上有多个考生，因此，在使用等效分时，最好结合省排名来综合判断，使两个数据的偏差得到有效的纠正，因为在同分比较多的情况下，1分之差可能相差百名之外。
                  </div>
                <th colspan="3">等效分</th>
                </el-tooltip>
                <th colspan="2">计划人数</th>
                <th rowspan="2" v-if="type==='2'">操作</th>
              </tr>
              <tr>
                <th>最低分</th>
                <th>平均分</th>
                <th>最高分</th>
                <th>投档线</th>
                <el-tooltip placement="top">
                  <div slot="content">
                    是院校当年最低录取分数与该院校在该省所在招生批次录取控制分数线的差值
                  </div>
                  <th>线差</th>
                </el-tooltip>
                <el-tooltip placement="top">
                  <div slot="content">我的省排名<span v-text="userInfo.spm"></span></div>
                  <th>入档位次</th>
                </el-tooltip>
                <th>最低分</th>
                <th>平均分</th>
                <th>最高分</th>
                <th>往年</th>
                <th>今年</th>
              </tr>
              <tr v-for="(innerItem, index) in item.subs" :key="index">
                <td>{{ innerItem.nd===0?'平均':innerItem.nd }}</td>
                <td>{{innerItem.zdf===''||innerItem.zdf===null?'-':innerItem.zdf}}</td>
                <td>{{innerItem.pjf===''||innerItem.pjf===null?'-':innerItem.pjf}}</td>
                <td>{{innerItem.zgf===''||innerItem.zgf===null?'-':innerItem.zgf}}</td>
                <td>{{innerItem.tdx===''||innerItem.tdx===null?'-':innerItem.tdx}}</td>
                <td>{{innerItem.xc===''||innerItem.xc===null?'-':innerItem.xc}}</td>
                <td>{{innerItem.rdwc===''||innerItem.rdwc===null?'-':innerItem.rdwc}}</td>
                <td v-if="innerItem.nd===0" class="yuceTdx">{{innerItem.zdtwf===''||innerItem.zdtwf===null?'-':innerItem.zdtwf}}</td>
                <td v-if="innerItem.nd!==0">{{innerItem.zdtwf===''||innerItem.zdtwf===null?'-':innerItem.zdtwf}}</td>
                <td>{{innerItem.pjtwf===''||innerItem.pjtwf===null?'-':innerItem.pjtwf}}</td>
                <td>{{innerItem.zgtwf===''||innerItem.zgtwf===null?'-':innerItem.zgtwf}}</td>
                <td>{{innerItem.wnjhs===''||innerItem.wnjhs===null?'-':innerItem.wnjhs}}</td>
                <td rowspan="4" v-if="index===0">{{innerItem.jnjhs===''||innerItem.jnjhs===null?'-':innerItem.jnjhs}}</td>
                <td rowspan="4" v-if="type==='2'&&index===0">
                  <el-button size="small" type="primary" @click="toZyzDetail(item.gbdm,item.zyz,
                  item.pc,item.yxmc,item.yxxh,null,item)" :disabled="item.isCanDisabled"
                  :loading="item.isCanDisabled">
                    <span v-if="!item.isCanDisabled" style="margin: 0 4px;">专业组详情</span>
                    <span v-if="item.isShowZyzDetail===false" class="el-icon-arrow-up"></span>
                    <span v-else class="el-icon-arrow-down"></span>
                  </el-button>
                  <!-- <el-button size="small" type="primary" style="margin-top: 4px;">查看</el-button> -->
                </td>
              </tr>
            </table>
          </div>
        </div>
      </div>
          <div v-show="item.isShowZyzDetail" class="schoolIntro_con2">
                    <div class="catTitle2">
                        <h2>专业组历年数据对比</h2>
                    </div>
                    <div class="txt"  id="lqTab" v-if="zyzTotals.list&&zyzTotals.list.length>0">
                        <table class="info-data" style="box-sizing: border-box;">
                            <tr>
                                <th rowspan="2">专业组</th>
                                <th rowspan="2">年度</th>
                                <th colspan="6">录取分</th>
                                <th colspan="3">等效分</th>
                                <th>计划人数</th>
                            </tr>
                            <tr>
                                <th>最低分</th>
                                <th>平均分</th>
                                <th>最高分</th>
                                <th>投档线</th>
                                <th>线差</th>
                                <el-tooltip placement="top">
                                <div slot="content">我的省排名{{userInfo.spm}}</div>
                                <th>入档位次</th>
                                </el-tooltip>
                                <th>最低分</th>
                                <th>平均分</th>
                                <th>最高分</th>
                                <th>今年</th>
                            </tr>
                                <tbody v-for="(item0,index0) in zyzTotals.list" :key="index0">
                                <tr v-for="(item2,index) in item0.sub" :key="index">
                                <td :rowspan="zyzRowspan" v-if="index===0">
                                    <a href="javascript:void(0)" style="color:black;">{{item0.zyz}}</a>
                                </td>
                                <td>{{item2.nd?item2.nd:item2.nd===0?'平均分':'-'}}</td>
                                <td>{{!item2.zdf?'-':item2.zdf}}</td>
                                <td>{{!item2.pjf?'-':item2.pjf}}</td>
                                <td>{{!item2.zgf?'-':item2.zgf}}</td>
                                <td>{{!item2.tdx?'-':item2.tdx}}</td>
                                <td>{{!item2.xc?'-':item2.xc}}</td>
                                <td>{{!item2.rdwc?'-':item2.rdwc}}</td>
                                <td v-if="item2.nd===0" class="yuceTdx">{{!item2.zdtwf?'-':item2.zdtwf}}</td>
                                <td v-if="item2.nd!==0">{{!item2.zdtwf?'-':item2.zdtwf}}</td>
                                <td>{{!item2.pjtwf?'-':item2.pjtwf}}</td>
                                <td>{{!item2.zgtwf?'-':item2.zgtwf}}</td>
                                <td :rowspan="zyzRowspan" v-if="index===0">{{item2.jnjhs}}</td>
                                </tr>
                                </tbody>
                        </table>
                    </div>
                    <div class="catTitle2">
                        <h2>专业详情表</h2>
                    </div>
                    <div class="txt order" style="width:990px;">
                    <div class="yx_zy_group">
                        <div class="group_title">
                            <div class="zyz_title">专业组{{zyz}}</div>
                            <div class="collect" :loading="collectLoading" v-if="isSc===0" @click="addCollect(zyz,zyzTotals.sfsc)">加入收藏</div>
                            <div class="collect" :loading="collectLoading" v-if="isSc===1" @click="addCollect(zyz,zyzTotals.sfsc)">取消收藏</div>
                        </div>
                        <div class="group_content" v-for="(item2,index) in zyTotals"
                        :key="index">
                            <div class="zy_name" :title="item2.zybz">
                                <span class="index">{{index+1}}</span>
                                <span :class="[item2.isRed?'seMangSeRuo':'']"> {{item2.zymc}} </span>
                                <!-- {{item2.zymc}} -->
                                <span class="tip">{{item2.zybz}}</span>
                            </div>
                            <div class="zy_attrs">
                                <div class="attr-item">
                                    <span v-if="item2.sxkm===2">首选科目：物理</span>
                                    <span v-if="item2.sxkm===1">首选科目：历史</span>
                                </div>
                                <div class="attr-item">
                                    <span>再选科目要求：{{item2.zxkmyq}}</span>
                                </div>
                                <div class="attr-item">
                                    <span>今年计划数：{{item2.jnjhs}}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div id="zyData">
                      <!-- max-height="770" -->
                        <el-table :data="zyData.filter(data=>!searchZy||data.zymc.indexOf(searchZy)>=0)"
                         :span-method="objectSpanMethod" max-height="770"
                        :header-cell-style="{'background-color':'#f5f7fa','border': '1px solid #09F',
                        'color': 'rgb(144, 147, 153)','text-align':'center','font-weight':'700','font-size':'14px'}" :cell-class-name="getCellClass"
                        :cell-style="objectCellMethod" size="small">
                        <el-table-column show-overflow-tooltip label="专业名称" prop="zymc" width="115" :resizable="false"></el-table-column>
                        <el-table-column show-overflow-tooltip label="一流学科" prop="zdzy" width="75" :resizable="false">
                            <template slot-scope="scope">
                                <img style="width:25px;height:25px;" src="../assets/images/gou.png" v-if="scope.row.zdzy===1"/>
                            </template>
                        </el-table-column>
                        <el-table-column show-overflow-tooltip label="年份" width="70" prop="nd" :resizable="false">
                            <template slot-scope="scope">
                                <span v-if="scope.row.nd!==0">{{scope.row.nd}}</span>
                                <span v-if="scope.row.nd===0">平均</span>
                            </template>
                        </el-table-column>
                        <el-table-column show-overflow-tooltip label="录取分" :resizable="false">
                            <el-table-column label="最低" width="75" prop="zdf" :resizable="false"></el-table-column>
                            <el-table-column label="平均" width="75" prop="pjf" :resizable="false"></el-table-column>
                        </el-table-column>
                        <el-table-column show-overflow-tooltip label="专业线差" width="75" prop="xc" :resizable="false"></el-table-column>
                        <el-table-column show-overflow-tooltip label="专业入档位次" width="70" prop="rdwc" :resizable="false"></el-table-column>
                        <el-table-column show-overflow-tooltip label="等效分" :resizable="false">
                            <el-table-column label="最低" width="65" prop="zdtwf" :resizable="false"></el-table-column>
                            <el-table-column label="平均" width="65" prop="pjtwf" :resizable="false"></el-table-column>
                        </el-table-column>
                        <el-table-column show-overflow-tooltip label="往年批次" width="70" prop="pc" :resizable="false">
                            <template slot-scope="scope">
                                <span v-if="scope.row.pc===6">本科批</span>
                                <span v-if="scope.row.pc===7">专科批</span>
                            </template>
                        </el-table-column>
                        <el-table-column show-overflow-tooltip label="计划人数" :resizable="false">
                            <el-table-column label="历年" width="65" prop="jhs" :resizable="false"></el-table-column>
                            <el-table-column label="今年" width="65" prop="jnjhrs" :resizable="false"></el-table-column>
                        </el-table-column>
                        <el-table-column show-overflow-tooltip label="操作" :resizable="false"
                        :key="updateZyList" align="center">      
                          <template slot="header">
                            <el-input
                              v-model="searchZy"
                              size="mini"
                              placeholder="输入关键字搜索"/>
                          </template>
                          <template slot-scope="scope">
                            <el-button type="primary" size="small" @click="addSchoolList(scope.row,showYxObj)"
                            v-if="scope.row.zyBtnTxt.indexOf('专业')===-1" :disabled="scope.row.isDisabled">{{ scope.row.zyBtnTxt }}</el-button>
                            <el-button size="small" @click="addSchoolList(scope.row,showYxObj)"
                            v-if="scope.row.zyBtnTxt.indexOf('专业')>=0" :disabled="scope.row.isDisabled"
                            style="background-color: #0479f5;color: white;border: 1px solid #0479f5;">{{ scope.row.zyBtnTxt }}</el-button>
                          </template>
                        </el-table-column>
                    </el-table>
                    </div>
                    </div>
          </div>
          <el-dialog :visible.sync="dialogListVisible" width="60%" title="志愿表（未保存）">
            <div style="display: flex;">
              <div style="width: 64px;text-align: left;">序号</div>
              <!-- <div style="width: 75px;text-align: center;">院校代码</div>
              <div style="width: 75px;text-align: center;">院校名称</div>
              <div style="width: 64px;text-align: center;">专业组</div>
              <div style="width: 75px;text-align: center;">批次</div> -->
              <div style="width: 289px;text-align: left;">院校专业组</div>
              <div style="width: 75px;text-align: left;">招生计划</div>
              <div style="width: 75px;text-align: left;">入档位次</div>
              <div style="width: 75px;text-align: left;">投档线</div>
              <div style="width: 111px;text-align: left;">等效分</div>
            </div>
            <div style="display: flex;">
              <div style="width: 64px;text-align: left;"></div>
              <!-- <div style="width: 75px;text-align: center;"></div>
              <div style="width: 75px;text-align: center;"></div>
              <div style="width: 64px;text-align: center;"></div>
              <div style="width: 75px;text-align: center;"></div> -->
              <div style="width: 289px;text-align: left;"></div>
              <div style="width:37px;text-align: left;">上年</div>
              <div style="width:37px;text-align: left;">当年</div>
              <div style="width:37px;text-align: left;">上年</div>
              <div style="width:37px;text-align: left;">当年</div>
              <div style="width: 75px; text-align: left;">上年</div>
              <div style="width:37px;text-align: left;">最低</div>
              <div style="width:37px;text-align: left;">平均</div>
              <div style="width:37px;text-align: left;">最高</div>
            </div>
            <div></div>
          </el-dialog>
          <el-dialog :visible.sync="dialogZyVisible" width="70%"
          :before-close="handleClose">
            <div style="display: flex;align-items: center;">
              <div style="width: 80px; height: 80px;box-sizing: border-box; margin: 0 30px;">
                <img v-if="showYxObj.gbdm"
                  :src="imgBaseUrl+showYxObj.gbdm+'.jpg'"
                  :alt="showYxObj.yxmc" width="100%">
              </div>
              <div>
                    <h3 style="font-size: 18px;">
                        {{ showYxObj.yxmc }}
                    <template v-if="showYxObj.sf985===1">
                        <img src="../assets/images/ico2.png" title="985">
                    </template>
                    <template v-if="showYxObj.sf211===1">
                        <img src="../assets/images/ico1.png" title="211">
                    </template>
                    <template v-if="showYxObj.sfsyl===1">
                        <img src="../assets/images/ico8.png" title="双一流">
                    </template>
                    <template v-if="showYxObj.sf101===1">
                        <img src="../assets/images/ico9.png" title="101">
                    </template>
                    <template v-if="showYxObj.yfyjsy===1">
                        <img src="../assets/images/ico3.png" title="研究生院">
                    </template>
                    </h3>
              </div>
            </div>
                    <div class="catTitle2">
                        <h2>专业组历年数据对比</h2>
                    </div>
                    <div class="txt"  id="lqTab" v-if="zyzTotals.list&&zyzTotals.list.length>0">
                        <table class="info-data" style="box-sizing: border-box;">
                            <tr>
                                <th rowspan="2">专业组</th>
                                <th rowspan="2">年度</th>
                                <th colspan="6">录取分</th>
                                <th colspan="3">等效分</th>
                                <th>计划人数</th>
                            </tr>
                            <tr>
                                <th>最低分</th>
                                <th>平均分</th>
                                <th>最高分</th>
                                <th>投档线</th>
                                <th>线差</th>
                                <el-tooltip placement="top">
                                <div slot="content">我的省排名{{userInfo.spm}}</div>
                                <th>入档位次</th>
                                </el-tooltip>
                                <th>最低分</th>
                                <th>平均分</th>
                                <th>最高分</th>
                                <th>今年</th>
                            </tr>
                                <tbody v-for="(item0,index0) in zyzTotals.list" :key="index0">
                                <tr v-for="(item2,index) in item0.sub" :key="index">
                                <td :rowspan="zyzRowspan" v-if="index===0">
                                    <a href="javascript:void(0)" style="color:black;">{{item0.zyz}}</a>
                                </td>
                                <td>{{item2.nd?item2.nd:item2.nd===0?'平均分':'-'}}</td>
                                <td>{{!item2.zdf?'-':item2.zdf}}</td>
                                <td>{{!item2.pjf?'-':item2.pjf}}</td>
                                <td>{{!item2.zgf?'-':item2.zgf}}</td>
                                <td>{{!item2.tdx?'-':item2.tdx}}</td>
                                <td>{{!item2.xc?'-':item2.xc}}</td>
                                <td>{{!item2.rdwc?'-':item2.rdwc}}</td>
                                <td v-if="item2.nd===0" class="yuceTdx">{{!item2.zdtwf?'-':item2.zdtwf}}</td>
                                <td v-if="item2.nd!==0">{{!item2.zdtwf?'-':item2.zdtwf}}</td>
                                <td>{{!item2.pjtwf?'-':item2.pjtwf}}</td>
                                <td>{{!item2.zgtwf?'-':item2.zgtwf}}</td>
                                <td :rowspan="zyzRowspan" v-if="index===0">{{item2.jnjhs}}</td>
                                </tr>
                                </tbody>
                        </table>
                    </div>
                    <div class="catTitle2">
                        <h2>专业详情表</h2>
                    </div>
                    <div class="txt order" style="width:890px;">
                    <div class="yx_zy_group">
                        <div class="group_title">
                            <div class="zyz_title">专业组{{zyz}}</div>
                            <!-- <div class="collect">查看填报情况</div> -->
                        </div>
                        <div class="group_content" v-for="(item2,index) in zyTotals"
                        :key="index">
                            <div class="zy_name" :title="item2.zybz">
                                <span class="index">{{index+1}}</span>
                                <span :class="[item2.isRed?'seMangSeRuo':'']"> {{item2.zymc}} </span>
                                <!-- {{item2.zymc}} -->
                                <span class="tip">{{item2.zybz}}</span>
                            </div>
                            <div class="zy_attrs">
                                <div class="attr-item">
                                    <span v-if="item2.sxkm===2">首选科目：物理</span>
                                    <span v-if="item2.sxkm===1">首选科目：历史</span>
                                </div>
                                <div class="attr-item">
                                    <span>再选科目要求：{{item2.zxkmyq}}</span>
                                </div>
                                <div class="attr-item">
                                    <span>今年计划数：{{item2.jnjhs}}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div id="zyData">
                        <el-table :data="zyData" max-height="770" :span-method="objectSpanMethod"
                        :header-cell-style="{'background-color':'#f5f7fa','border': '1px solid #09F',
                        'color': 'rgb(144, 147, 153)','text-align':'center','font-weight':'700','font-size':'14px'}"
                        :cell-class-name="getCellClass"
                        :cell-style="objectCellMethod" size="small"
                        >
                        <el-table-column show-overflow-tooltip label="专业名称" prop="zymc" width="105" :resizable="false"></el-table-column>
                        <el-table-column show-overflow-tooltip label="一流学科" prop="zdzy" width="65" :resizable="false">
                            <template slot-scope="scope">
                                <img style="width:25px;height:25px;" src="../assets/images/gou.png" v-if="scope.row.zdzy===1"/>
                            </template>
                        </el-table-column>
                        <el-table-column show-overflow-tooltip label="年份" width="60" prop="nd" :resizable="false">
                            <template slot-scope="scope">
                                <span v-if="scope.row.nd!==0">{{scope.row.nd}}</span>
                                <span v-if="scope.row.nd===0">平均</span>
                            </template>
                        </el-table-column>
                        <el-table-column show-overflow-tooltip label="录取分" :resizable="false">
                            <el-table-column label="最低" width="65" prop="zdf" :resizable="false"></el-table-column>
                            <el-table-column label="平均" width="65" prop="pjf" :resizable="false"></el-table-column>
                        </el-table-column>
                        <el-table-column show-overflow-tooltip label="专业线差" width="65" prop="xc" :resizable="false"></el-table-column>
                        <el-table-column show-overflow-tooltip label="专业入档位次" width="60" prop="rdwc" :resizable="false"></el-table-column>
                        <el-table-column show-overflow-tooltip label="等效分" :resizable="false">
                            <el-table-column label="最低" width="65" prop="zdtwf" :resizable="false"></el-table-column>
                            <el-table-column label="平均" width="55" prop="pjtwf" :resizable="false"></el-table-column>
                        </el-table-column>
                        <el-table-column show-overflow-tooltip label="往年批次" width="60" prop="pc" :resizable="false">
                            <template slot-scope="scope">
                                <span v-if="scope.row.pc===6">本科批</span>
                                <span v-if="scope.row.pc===7">专科批</span>
                            </template>
                        </el-table-column>
                        <el-table-column show-overflow-tooltip label="计划人数" :resizable="false">
                            <el-table-column label="历年" width="55" prop="jhs" :resizable="false"></el-table-column>
                            <el-table-column label="今年" width="55" prop="jnjhrs" :resizable="false"></el-table-column>
                        </el-table-column>
                        <el-table-column show-overflow-tooltip label="操作" :resizable="false"
                        :key="updateZyList" align="center" header-align="center">
                          <template slot-scope="scope">
                            <el-button type="primary" size="small" @click="addSchoolList(scope.row,showYxObj)"
                            v-if="scope.row.zyBtnTxt.indexOf('专业')===-1">{{ scope.row.zyBtnTxt }}</el-button>
                            <el-button type="success" size="small" @click="addSchoolList(scope.row,showYxObj)"
                            v-if="scope.row.zyBtnTxt.indexOf('专业')>=0">{{ scope.row.zyBtnTxt }}</el-button>
                          </template>
                        </el-table-column>
                    </el-table>
                    </div>
                    </div>
          </el-dialog>
    </div>
  </div>
  <!-- <div v-else>
    <div
      class="school-info"
      v-for="(item, index) in schoolData.data.list"
      :key="index"
    >
      <div class="info-logo">
        <router-link
          tag="a"
          target="_blank"
          :to="{
            path: '/main/schoolDetail' + jQueryroute.path,
            query: { item: item.gb }
          }"
        >
          <img :src="item.logo" alt="院校logo" width="100%" height="100%" />
        </router-link>
      </div>
      <div class="info-introduce">
        <div class="school-name">
          <router-link
            tag="a"
            target="_blank"
            :to="{
              path: '/main/schoolDetail' + jQueryroute.path,
              query: { item: item.gb }
            }"
          >
            <h3>{{ item.yxmc }}</h3>
          </router-link>
          <div class="school-lqgl" v-if="jQueryroute.path === '/schoolRecommend'">
            (录取率:{{ item.lqgl }}%)
          </div>
        </div>
        <div class="school-category">
          <div class="category-wrap category-type">
            <div class="category-item top-positon">
              院校性质:
              <span v-if="item.sfgb !== '0'">公办&nbsp;</span>
              <span v-else-if="item.sfmb !== '0'">民办&nbsp;</span>
              <span v-else-if="item.sfdl !== '0'">独立学院&nbsp;</span>
              <span v-else>暂无信息</span>
            </div>
            <div class="category-item top-positon">
              院校属性:
              <span v-if="item.sf985 !== '0'">985&nbsp;</span>
              <span v-if="item.sf211 !== '0'">211&nbsp;</span>
              <span v-else>普通高校</span>
            </div>
            <div class="category-item top-positon">
              所在省份:{{ item.yxdq }}
            </div>
            <div class="category-item">
              <button
                type="button"
                class="deleteSchool"
                v-if="item.collect"
              >
                取消收藏
              </button>
              <button
                type="button"
                class="addSchool"
                v-else
              >
                加入收藏
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div> -->

    <div class="compareLayout" id="compare_box" style="bottom:-300px;">
    <div class="hd">
      <ul class="tab" style="margin-bottom: 0;">
        <li class="current">院校对比</li>
      </ul>
      <div class="close"><a href="javascript:;" @click="hideYxdb">隐藏</a></div>
    </div>
    <div class="bd">
      <ul class="list" style="display:block;">
        <!-- 对比选项容器 -->
        <div id="compare_item_box">
            <li class="compare_item" style="float: left;width: 16.5%;text-align: center;"
            v-for="(item,index) in compareSchool" :key="index">
              <div class="box" style="border-right: 1px dashed #D4D4D4;height: 140px;padding-top: 8px;">
                <div class="schoolLogo" style="width: 120px;height: 80px;margin: 0 auto 5px;">
                  <a href="#">
                    <img width="80" height="80" :alt="item.yxmc" :src="item.logo">
                  </a>
                </div>
                <div class="tit" style="display: flex; flex-direction:column">{{item.yxmc}}
                  <br /><a href="javascript:;" @click="deleteYxdb(index)">[取消对比]</a>
                </div>
              </div>
            </li>
        </div>
        <!-- 对比按钮 -->
        <li id="compare_tool">
          <div class="box">
            <div class="button" id="compare_button">
              <a href="javascript:;" @click="zyFsdb" class="btn" style="display: none;">专业录取分数对比</a>
              <a href="javascript:;" @click="yxDbTable" class="btn" style="color: #005aa0;">
                <!-- <div>院校基本</div>
                <div>情况对比表</div> -->
                院校基本情况对比表
              </a>
            </div>
            <a href="javascript:;" @click="clearYxdb" style="border:1px solid black; color: blue;
            font-size: 18px;display: block;margin: 8px auto 5px;margin-top: 15px;width: 130px;">清空对比栏</a>
          </div>
        </li>
      </ul>
    </div>
  </div>
</div>
</template>
<script>
import {mapState} from 'vuex';
import jQuery from 'jquery';
import {Message} from 'element-ui';
import router from '../router/index';
import {imgBaseUrl} from "../common/imgBaseUrl";
export default {
props:["type"],
data(){
  return{
    jQuery:jQuery,
    currentArr:[],
    zyzTotals:{
    },
    zyData:[],
    zyTotals:{},
    detail:{},
    zyz:'',
    schoolList:[],
    dialogListVisible:false,
    dialogZyVisible:false,
    showYxObj:{},
    updateZyList:false,
    searchZy:'',
    collectLoading:false,
    isSc:0,
    imgBaseUrl:imgBaseUrl
  };
},
methods:{
// 封装的院校对比代码
yxdbCode(){
    // var compare;  // 全局变量，页面调用，给此赋值new Compare()即可
(function(jQuery){
    jQuery.fn.compare = function(option) {
        var defaults = {
          maxItem : 4,// 最大角标
          compareUrl : '/db/jbxx',// 对比基本情况地址
          compareUrlFs : '/db/lqfs',// 对比录取分数地址
          compareUrlZYFs : '/db/zyfs',// 对比专业地址
          zydm:"#zydms", // 传递专业代码
          itemBox : '#compare_item_box',// 存放对比项的id
          itemClass : '.compare_item',// 每个对比项的类
          buttonBox : '#compare_button', // 存放对比按钮的类
          okButton : 'btn',// ok时的对比按钮class
          errorButton : 'btnDisabled',// error时的对比按钮class
          urlPath : 'xx/xx/xx?yxxh=', // 院校详细查询的url
          runInit : true,// 是否进行初始化
          iszydb : false // 是否专业对比
        };
        // 配置项
        var opt = jQuery.extend({}, defaults, option);
        var comp = new Compare(jQuery(this), opt);
        return comp;
    };
    /**
    * 构造方法
    */
    function Compare(obj, setting) {
        this._obj = obj;
        this.maxItem = setting.maxItem;
        this.compareUrl = setting.compareUrl;
        this.compareUrlFs = setting.compareUrlFs;
        this.compareUrlZYFs = setting.compareUrlZYFs;
        this.itemBox = setting.itemBox;
        this.itemClass = setting.itemClass;
        this.buttonBox = setting.buttonBox;
        this.okButton = setting.okButton;
        this.errorButton = setting.errorButton;
        this.runInit = setting.runInit;
        this.urlPath = setting.urlPath;
        this.zydm=setting.zydm;
        this.iszydb = setting.iszydb;
        // 存放对比数据
        // this._data = new Array();
        this._data = [];
        if(this.runInit === true){
          this.init();
        }
    }
    /**
    * 初始化操作
    */
    Compare.prototype.init = function() {
        this.before();
        return this;
    };
    /**
    * 动作之前的判断行为
    */
    Compare.prototype.before = function() {
        var leng = this._data.length;
        if(leng<2){
          this._obj.find(this.buttonBox+" a").removeClass("btn");
          this._obj.find(this.buttonBox+" a").addClass("btnDisabled");
        }else{
          this._obj.find(this.buttonBox+" a").removeClass("btnDisabled");
          this._obj.find(this.buttonBox+" a").addClass("btn");
        }
        if(this.iszydb === false){
          this._obj.find(this.buttonBox+" a:first").hide(); // 如果不是专业对比，第一个不显示
        }
    };
    /**
      * 将信息添加到对比框
      * @param obj.sid  大学id
      * @param obj.title 大学标题
      * @param obj.logo  大学校徽
      * @param obj.comp_pc  大学批次
      */
    Compare.prototype.add = function(obj) {
        var isAppend = true; // 标识 判断是否添进新元素
        // var isAddClass = true; // 判断是否点击后添加CLASS样式
        var isMsg = '您已经添加过该大学了'; // 弹出友情提示的信息
        var isChoose = 1;
        // var item = new Object();
        var item = {};
        var $obj = jQuery(obj);
        item.id = $obj.attr("comp_id");
        item.title = $obj.attr("comp_yxmc");
        item.logo = $obj.attr("comp_logo");
        item.pc = $obj.attr("comp_pc");

        // 如果数组中有元素了 则开始判断
        if(this._data.length > 0) {
          // 插入之前先判断当前数组中是否含有此元素 通过唯一标识 大学id
          jQuery.each(this._data, function(k, v){
            if(v.id === item.id) {
              isAppend = false;
              return false;
            }
          });
          // alert(this.maxItem);
          // 如果添加到元素超过了最大限制 也不再添加了
          if(isAppend && this._data.length >= this.maxItem+1) {
            isAppend = false;
            isMsg = '最多不允许超过'+(this.maxItem+1)+'所大学';
            // layer.alert(isMsg);
            Message({message:isMsg});
          }
          // 如果已经选择了该大学，则进行反选操作
          if(!isAppend && isChoose === 1) {
            this.close(item.id);
            return false;
          }
        }
        // 插入新元素
        if(isAppend) {
          this._data.push(item);
          var appendHtml = '';
          // var url = this.urlPath;
          appendHtml = '<li class="compare_item del_id_'+item.id+'" style="float: left;width: 16.5%;text-align: center;"><div class="box" style="border-right: 1px dashed #D4D4D4;height: 140px;padding-top: 8px;"><div class="schoolLogo" style="width: 120px;height: 100px;margin: 0 auto 5px;"><a href="#"><img src="'+item.logo+'" width="80" height="80" alt="'+item.title+'" /></a></div><div class="tit" style="display: flex; flex-direction:column">'+item.title+'<br /></div></div></div></li>';
          this._obj.find(this.itemBox).append(appendHtml);
          // 显示对比框
          this.show();
          // 添加样式
          jQuery(obj).addClass('compare_btn_'+item.id+' current');
          jQuery(obj).text("取消院校对比");
        }
        this.show();
        return false;
    };
    /**
      * window.open到分数对比
      */
    Compare.prototype.compareDoFs = function (){
      var temp = this._data;
      var yxxhs = "";
      var pc = temp[0].pc;
      jQuery.each(temp,function(i,v){
        yxxhs += v.id+",";
      });
      yxxhs = yxxhs.substring(0,yxxhs.length-1);
      if(typeof (WeixinJSBridge)!=="undefined"){
        var i = sessionStorage.getItem("id");
        if(i == null||i===""){i=0;};
        i++;
        sessionStorage.setItem("id", i);
        sessionStorage.setItem("pre_href"+"_"+i, window.location.href);
      }
      window.open(this.compareUrlFs+"?yxxhs="+yxxhs+"&pc="+pc,"分数对比");
      return false;
    };
    /**
      * window.open到基本信息对比
      */
    Compare.prototype.compareDo = function (){
      var temp = this._data;
      var yxxhs = "";
      var pc = temp[0].pc;
      jQuery.each(temp,function(i,v){
        yxxhs += v.id+",";
      });
      yxxhs = yxxhs.substring(0,yxxhs.length-1);
      if(typeof (WeixinJSBridge)!=="undefined"){
        var i = sessionStorage.getItem("id");
        if(i == null||i===""){i=0;};
        i++;
        sessionStorage.setItem("id", i);
        sessionStorage.setItem("pre_href"+"_"+i, window.location.href);
      }
      const url= router.resolve({
        path:"/db/jbxx",
        query:{yxxhs:yxxhs,pc:pc}
      });
      window.open(url.href,"_blank");
      // window.open(this.compareUrl+"?yxxhs="+yxxhs+"&pc="+pc,"基本信息对比");
      return false;
    };
    /**
      * window.open到专业对比
      */
    Compare.prototype.compareZy = function (){
      var temp = this._data;
      var yxxhs = "";
      jQuery.each(temp,function(i,v){
        yxxhs += v.id+",";
      });
      yxxhs = yxxhs.substring(0,yxxhs.length-1);
      var zydm = jQuery("#zydms").val();
      if(typeof (WeixinJSBridge)!=="undefined"){
        var i = sessionStorage.getItem("id");
        if(i == null||i===""){i=0;};
        i++;
        sessionStorage.setItem("id", i);
        sessionStorage.setItem("pre_href"+"_"+i, window.location.href);
      }
      window.open(this.compareUrlZYFs+"?yxxhs="+yxxhs+"&zydm="+zydm,"专业分数对比");
      return false;
    };
    /**
      * 清空
      */
    Compare.prototype.clear = function() {
      this._obj.find(this.itemClass).remove();
      if(this._data.length > 0) {
        // 获取对比框中的数组
        jQuery.each(this._data, function(k, v){
          jQuery(document).find('.compare_btn_'+v.id).removeClass('current'); // 清除页面已经选择的
          jQuery(document).find('.compare_btn_'+v.id).text("加入院校对比");
        });
      }
      // this._data = new Array();
      this._data = [];
      this.before();
      return this;
    };
    /**
    * 显示对比框 不包含数据 ;
    */
    Compare.prototype.show = function(){
        this.before();
        this._obj.animate({
          bottom:0
        }, 500);
        this.cstyle();
        return this;
    };
    /**
      * 删除掉指定的对比元素
      */
    Compare.prototype.close = function(sid) {
      // var tmp = new Array();
      var tmp = [];
      // 重新创建数组，不包括 被删除掉的大学
      jQuery.each(this._data, function(k, v){
        if(sid !== v.id) {
          tmp.push(v);
        }
      });
      // 删除标签元素
      this._obj.find('.del_id_'+sid).remove();
      jQuery(document).find('.compare_btn_'+sid).removeClass('current');
      jQuery(document).find('.compare_btn_'+sid).text("加入院校对比");
      this._data = tmp;
      this.before();
      return this;
    };
    /**
    * 隐藏
    */
    Compare.prototype.hide = function(){
        this.before();
        this._obj.animate({
          bottom:'-300px'
        }, 500);
        this.restyle();
        return this;
    };
    /**
     * 检查一个加入对比的元素是否是在对比数组中,并操作设置成加入对比
     **/
    Compare.prototype.fullOne = function(obj){
      if(this._data.length > 0) {
        jQuery.each(this._data, function(index, v){
          if(jQuery(obj).attr("comp_id") === v.id) {
            jQuery(obj).addClass('compare_btn_'+v.id+' current');
            jQuery(obj).text("取消对比");
            return false;
          }
        });
      }
    };
    /**
     * 需要修改页面的样式
     */
    Compare.prototype.cstyle = function() {
      if(this.iszydb){
        jQuery("#majorContent").css('marginBottom', '110px');
      }else{
        jQuery('#loadcontent').css('marginBottom', '110px');
      }
    };

    /**
     * 修复原来的样式
     */
    Compare.prototype.restyle = function() {
      if(this.iszydb){
        jQuery("#majorContent").css('marginBottom', '20px');
      }else{
        jQuery('#loadcontent').css('marginBottom', '10px');
      }
    };
})(jQuery);
},
// 初始化院校对比
initYxdb(){
  jQuery.compare = jQuery("#compare_box").compare({
        iszydb: false
      });
},
// 点击加入院校对比
yxdbClick(e,item,index,flag){
  // jQuery.compare.add(e.target);
      jQuery.compare.show();
    this.isShowCompare=true;
    if(flag===1){
      const arr=[];
      const compares=this.compareSchool;
      if(compares.length>4){
        const msg="最多不允许超过"+(compares.length+"所学校");
        this.$message({
          message:msg
        });
        return;
      }
      const currentArr=[...this.currentArr];
      currentArr.push(index);
      this.currentArr=currentArr;
      arr.push({pc:item.pc,yxxh:item.yxxh,yxmc:item.yxmc,logo:imgBaseUrl+item.gbdm+'.jpg'});
      this.$store.dispatch("saveCompareSchool",{compareSchool:[...this.compareSchool,...arr]});
    }else{
      let dqSchoolIndex=-1;
      const schoolArr=[...this.compareSchool];
      for(let i=0;i<schoolArr.length;i++){
        if(schoolArr[i].yxxh===item.yxxh){
          dqSchoolIndex=i;
          break;
        }
      }
      if(dqSchoolIndex>=0){
        schoolArr[dqSchoolIndex]=null;
        const saveSchoolArr=schoolArr.filter(item=>item!==null);
        this.$store.dispatch("saveCompareSchool",{compareSchool:saveSchoolArr});
      }
      const currentArr=[...this.currentArr];
      let currentIndex=-1;
      for(let i=0;i<currentArr.length;i++){
        if(currentArr[i]===index){
          currentIndex=i;
          break;
        }
      }
      if(currentIndex>=0){
        currentArr[currentIndex]=null;
        this.currentArr=currentArr.filter(item=>item!==null);
      }
    }
  return false;
},
// 清空对比表
clearYxdb(){
//  jQuery.compare.clear();
      this.$store.dispatch("initCompareSchool");
      this.currentArr=[];
},
// 点击专业录取分数对比
zyFsdb(){
  jQuery.compare.compareZy();
},
// 点击院校基本情况对比
yxDbTable(){
  // jQuery.compare.compareDo();
      const arr=this.compareSchool;
    let yxxhs='';
    for(let i=0;i<arr.length;i++){
      const yxxh=arr[i].yxxh;
      if(yxxh){
        if(i===arr.length-1){
          yxxhs+=yxxh;
        }else{
          yxxhs+=yxxh+",";
        }
      }
    }
    const pc=arr[0].pc;
    this.$store.commit('initIsUpdateToken');
    const url= router.resolve({
        path:"/main/db/jbxx",
        query:{yxxhs:yxxhs,pc:pc}
    });
    window.open(url.href,"_blank");
},
// 隐藏院校对比
hideYxdb(){
  jQuery.compare.hide();
},
// 取消院校对比
cancelYxdb(id){
  jQuery.compare.close(id);
},
async toZyzDetail(gbdm, zyz = null,pc,yxmc,yxxh,type=null,obj){
    const list=[...this.recommendData.data.list];
    let index=0;
    for(let i=0;i<list.length;i++){
      if(list[i].yxmc===obj.yxmc&&list[i].zyz===obj.zyz){
        index=i;
        break;
      }
    }
    list[index].isCanDisabled=true;
    this.$store.commit("getRecommend",{recommendData:{data:{list:list,
      total:this.recommendData.data.total,pageSize:this.recommendData.data.pageSize,
      pageNum:this.recommendData.data.pageNum}}});
  await this.getZyzDetail(gbdm,zyz,pc,yxmc,yxxh,type,obj);
    if(!list[index].isShowZyzDetail){
      for(let i=0;i<list.length;i++){
        if(list[i].yxmc){
          list[i].isShowZyzDetail=false;
        }
      }
      list[index].isShowZyzDetail=true;
    }else{
      list[index].isShowZyzDetail=false;
    }
    list[index].isCanDisabled=false;
    this.showYxObj={...obj};
    this.$store.commit("getRecommend",{recommendData:{data:{list:list,
      total:this.recommendData.data.total,pageSize:this.recommendData.data.pageSize,
      pageNum:this.recommendData.data.pageNum}}});
},
async toZyzDetail2(gbdm, zyz = null,pc,yxmc,yxxh,type=null,obj){
    const list=[...this.recommendData.data.list];
    let index=0;
    for(let i=0;i<list.length;i++){
      if(list[i].yxmc===obj.yxmc&&list[i].zyz===obj.zyz){
        index=i;
        break;
      }
    }
    list[index].isCanDisabled=true;
    this.$store.commit("getRecommend",{recommendData:{data:{list:list,
      total:this.recommendData.total,pageSize:this.recommendData.pageSize,
      pageNum:this.recommendData.pageNum}}});
  await this.getZyzDetail(gbdm,zyz,pc,yxmc,yxxh,type,obj);
    list[index].isCanDisabled=false;
    this.$store.commit("getRecommend",{recommendData:{data:{list:list,
      total:this.recommendData.total,pageSize:this.recommendData.pageSize,
      pageNum:this.recommendData.pageNum}}});
      this.showYxObj={...obj};
      this.dialogZyVisible=true;
},
async getZyzDetail(gbdm, zyz = null,pc,yxmc,yxxh,type=null,obj){
        const res=await this.$http.postHttp("/yxcx/getYxZyzDetail",{
            gbdm,
            zyz,
            pc,
            yxmc,
            yxxh
        });
        console.log(res);
        const selectZyData=[];
        if(res.data.code===200){
            this.detail.logo=res.data.obj.yxml.logo;
            this.detail.dz=res.data.obj.yxml.dz;
            this.detail.wz=res.data.obj.yxml.xxwz;
            this.detail.yxmc=res.data.obj.yxmcStr;
            this.detail.jj=res.data.obj.yxml.jj;
            this.detail.jxsj=res.data.obj.yxml.jxsj;
            this.detail.ls=res.data.obj.yxml.ls;
            this.detail.xsrs=res.data.obj.yxml.xsrs;
            this.detail.bsdgs=res.data.obj.yxml.bsdgs;
            this.detail.ysrs=res.data.obj.yxml.ysrs;
            this.detail.ssdgs=res.data.obj.yxml.ssdgs;
            this.detail.nsbl=res.data.obj.yxml.nsbfb;
            this.detail.nvsbl=res.data.obj.yxml.nvsbfb;
            this.detail.xfxx=res.data.obj.yxml.xfxx;
            this.detail.jyqk=res.data.obj.yxml.jyqk;
            this.detail.ylxks=res.data.obj.zdzys;
            this.detail.szdqmc=res.data.obj.yxml.szdqmc;
            this.detail.dh=res.data.obj.yxml.dh;
            this.detail.dzyx=res.data.obj.yxml.dzyj;
            this.detail.zswz=res.data.obj.yxml.zswz;
            this.detail.zszc=res.data.obj.yxml.zszc;
            this.detail.yymc=res.data.obj.yxml.yxywmc;
            this.detail.sf985=res.data.obj.yxml.sf985;
            this.detail.sf211=res.data.obj.yxml.sf211;
            this.detail.sfsyl=res.data.obj.yxml.sfsyl;
            this.detail.yfyjsy=res.data.obj.yxml.yfyjsy;
            this.detail.sf101=res.data.obj.yxml.sf101;
            this.detail.gbdm=res.data.obj.yxml.gbdm;
            this.detail.xxlb=res.data.obj.yxml.xxlb;
            this.detail.xxlbmc=res.data.obj.yxml.xxlbmc;
            this.detail.ylxkSize=res.data.obj.zdzysSize;
            this.detail.yxxh=res.data.obj.yxxhStr;
            this.detail.pc=pc;
            for(let i=1;i<7;i++){
              if(res.data.obj['zydh'+i]){
                selectZyData.push(res.data.obj['zydh'+i]);
              }
            }
        }else if(res.data.code===500){
            if(res.data.message){
                this.$message({message:res.data.message,type:"error"});
            }else if(res.data.msg){
                this.$message({message:res.data.msg,type:"error"});
            }
        }else if(res.status===401){
            this.$message({message: '登录超时，请重新登录',type:"error"});
            await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
            this.$router.replace({
                path: '/main/home',
                query: {redirect: this.$router.currentRoute.fullPath}
            });
        }else if(res.data.code===0){
            this.$message({message:"您的账号在其他地点登陆了！",showClose:true,type:"warning"});
            await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
            this.$router.replace({
                path: '/main/home',
                query: {redirect: this.$router.currentRoute.fullPath}
            });
        }else if(res.status===409||res.status===410||res.status===411){
            this.$message({message:"您的账号在其他地点登陆了！",showClose:true,type:"warning"});
            await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
            this.$router.replace({
                path: '/main/home',
                query: {redirect: this.$router.currentRoute.fullPath}
            });
        }
        if(zyz===''){
            zyz=null;
        }
        if(type===''){
            type=null
        }
        const res2=await this.$http.postHttp("/yxcx/getLqxq",{
            kl:this.userInfo.kl,
            pc,
            yxxh,
            zxkma:this.userInfo.zxkma,
            zxkmb:this.userInfo.zxkmb,
            zyz,
            condition:type
        });
        if(res2.data.code===200){
            // this.zyzTotals=res2.data.obj.zyzTotals[0];
            const len=res2.data.obj.zyzTotals.length;
            const zyzs=res2.data.obj.zyzTotals;
            for(let i=0;i<len;i++){
                const zyz=zyzs[i].zyz;
                const isSc=res2.data.obj.zyz[zyz].isSc;
                if(isSc){
                    zyzs[i].isSc=1;
                }else{
                    zyzs[i].isSc=0;
                }
            }
            if(len===1){
                const isSc=res2.data.obj.zyz[zyzs[0].zyz].isSc;
                if(isSc){
                    this.isSc=1;
                }else{
                    this.isSc=0;
                }
            }
            console.log(res2);
            this.zyzTotals.list=res2.data.obj.zyzTotals;
            // this.zyzTotals.zyz=res2.data.obj.zyz;
            this.zyzRowspan=res2.data.obj.zyzTotals[0].sub.length;
            this.zyz=res2.data.obj.zyzTotals[0].zyz;
            this.zyTotals=res2.data.obj.zyz[zyzs[0].zyz].zylb;
            const zybzs=[...this.zyTotals];
            const bzlen=zybzs.length;
            for(let i=0;i<bzlen;i++){
                if(zybzs[i]){
                    zybzs[i].isRed=false;
                }
            }
            for(let i=0;i<bzlen;i++){
                console.log(zybzs[i]);
                if(zybzs[i].zybz&&zybzs[i].zybz.indexOf("色盲")>=0&&zybzs[i].zybz.indexOf("色弱")>=0){
                    zybzs[i].isRed=true;
                }
            }
            this.zyTotals=zybzs;
            const zyData=[];
            const zylb=res2.data.obj.zyz[zyzs[0].zyz].zylb;
            const zyLen=res2.data.obj.zyz[zyzs[0].zyz].zylb.length;
            for(let i=0;i<zyLen;i++){
                const subs=zylb[i].subs;
                for(let j=0;j<subs.length;j++){
                    if(j%4===0){
                      let selectedZydhIndex=-1;
                      for(let k=0;k<selectZyData.length;k++){
                        if(subs[j].zydh===selectZyData[k]){
                          selectedZydhIndex=k;
                          break;
                        }
                      }
                      if(selectedZydhIndex>=0){
                        subs[j].zyBtnTxt='专业'+(selectedZydhIndex+1);
                      }else{
                        subs[j].zyBtnTxt="填报";
                      }
                    }
                    subs[j].btnRightTopNum=0;
                    subs[j].isDisabled=false;
                    zyData.push(subs[j]);
                }
            }
            console.log(zyData);
            this.zyData=zyData;
            const schoolObj={};
            schoolObj.yxmc=yxmc;
            schoolObj.yxxh=yxxh;
            schoolObj.zyz=zyz;
            schoolObj.sb=null;
            schoolObj.pc=pc;
            schoolObj.sf985=this.detail.sf985;
            schoolObj.sf211=this.detail.sf211;
            schoolObj.snjhrs=0;
            schoolObj.jnjhrs=0;
            schoolObj.snrdwc=0;
            schoolObj.jnrdwc=0;
            schoolObj.tdx=0;
            schoolObj.zdtwf=0;
            schoolObj.pjtwf=0;
            schoolObj.zgtwf=0;
            schoolObj.sfsc=res2.data.obj.sfsc;
            for(let i=0;i<selectZyData.length;i++){
              if(selectZyData[i]){
                schoolObj['zy'+(i+1)]=selectZyData[i];
              }
            }
            const schoolArr=[];
            schoolArr.push(schoolObj);
            console.log(schoolObj);
            this.schoolList=[...schoolArr];
            // this.zyzRowspan=4;
            // this.zyzTotals.jnjhs=res2.data.obj.zyzTotals[0].sub[0].jnjhs;
            // this.zyzTotals.sfsc=res2.data.obj.sfsc;
        }else if(res2.data.code===500){
            if(res2.data.message){
                this.$message({message:res2.data.message,type:"error"});
            }else if(res2.data.msg){
                this.$message({message:res2.data.msg,type:"error"});
            }
        }else if(res2.status===401){
            this.$message({message: '登录超时，请重新登录',type:"error"});
            await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
            this.$router.replace({
                path: '/main/home',
                query: {redirect: this.$router.currentRoute.fullPath}
            });
        }else if(res2.data.code===0){
            this.$message({message:"您的账号在其他地点登陆了！",showClose:true,type:'warning'});
            await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
            this.$router.replace({
                path: '/main/home',
                query: {redirect: this.$router.currentRoute.fullPath}
            });
        }
        this.$forceUpdate();
},
getCellClass({row,column,columnIndex}){
        if(row%3===0&&columnIndex===7){
            return 'yuceTdx';
        }else{
            return '';
        }
},
objectCellMethod({row,column,rowIndex,columnIndex}){
        if(rowIndex%4===3&&columnIndex===7){
            return{'border':'1px solid #09F','text-align':'center','color':'#ED4A09','font-weight':'bold'};
        }else{
            return{'border':'1px solid #09F','text-align':'center'};
        }
},
zyCellClick(row, column, cell, event){
  if(column.label==='操作'){
    this.addSchoolList(row,this.showYxObj);
  }
},
async addSchoolList(obj,item){
  const yxmc=item.yxmc||obj.yxmc||"";
  const sb=item.sb||obj.sb||"";
  const zyz=item.zyz||obj.zyz||"";
  const yxxh=item.yxxh||obj.yxxh||"";
  const pc=item.pc||obj.pc||0;
  const sf985=item.sf985||obj.sf985||0;
  const sf211=item.sf211||obj.sf211||0;
  const sfsyl=item.sfsyl||obj.sfsyl||0;
  const sfyjsy=item.sfyjsy||obj.sfyjsy||0;
  const snjhrs=item.wnjhs||item.wnjhs||0;
  const jnjhrs=item.jnjhs||obj.jnjhs||0;
  let snrdwc=0;
  let jnrdwc=0;
  const subs=[...item.subs];
  let nds=[];
  for(let i=0;i<subs.length;i++){
    if(subs[i].nd>0){
      nds.push(subs[i].nd);
    }
  }
  nds=[...(new Set(nds))].sort(function(a,b){
  return b-a;
  });
  let tdx=0;
  let zdtwf=0;
  let pjtwf=0;
  let zgtwf=0;
  const nd1=nds[0];
  const nd2=nds[1];
  for(let i=0;i<subs.length;i++){
    if(subs[i].nd===nd1){
      jnrdwc=subs[i].rdwc;
      tdx=subs[i].tdx;
      zdtwf=subs[i].zdtwf;
      zgtwf=subs[i].zgtwf;
      pjtwf=subs[i].pjtwf;
    }else if(subs[i].nd===nd2){
      snrdwc=subs[i].rdwc;
    }
  }
  const zyData=[...this.zyData];
  let index=0;
  for(let i=0;i<zyData.length;i++){
    if(zyData[i].zymc===obj.zymc){
      index=i;
      break;
    }
  }
  // this.$set(this.zyData[index],'isDisabled',true);

  const data=[...this.zyData];
  data.forEach((item)=>{
      item.isDisabled=true;
  });
  this.zyData=data;
  const schoolObj={};
  schoolObj.yxmc=yxmc;
  schoolObj.yxxh=yxxh;
  schoolObj.zyz=zyz;
  schoolObj.sb=sb;
  schoolObj.pc=pc;
  schoolObj.sf985=sf985;
  schoolObj.sf211=sf211;
  schoolObj.snjhrs=snjhrs;
  schoolObj.jnjhrs=jnjhrs;
  schoolObj.snrdwc=snrdwc;
  schoolObj.jnrdwc=jnrdwc;
  schoolObj.tdx=tdx;
  schoolObj.zdtwf=zdtwf;
  schoolObj.pjtwf=pjtwf;
  schoolObj.zgtwf=zgtwf;
  const schoolList=[...this.schoolList];
  console.log(schoolList);
  let index2=0;
  for(let i=0;i<schoolList.length;i++){
    if(schoolList[i].yxmc===item.yxmc&&schoolList[i].zyz===item.zyz){
      index2=i;
      break;
    }
  }
  let count=0;
  let existFlag=false;
  let zyIndex=0;
  for(let i=1;i<7;i++){
    if(schoolList[index2]&&schoolList[index2]['zy'+i]&&schoolList[index2].yxmc===item.yxmc){
      if((schoolList[index2]['zy'+i]===obj.zydh)
      ||(schoolList[index2]['zy'+i]===obj.zydm)){
        existFlag=true;
        zyIndex=i;
      }
      count++;
    }
  }
  if(count===6&&!existFlag){
    this.$message({message:'每个志愿最多填报6个专业',type:'warning',showClose:true});
    const data=[...this.zyData];
    data.forEach((item)=>{
      item.isDisabled=false;
    });
    this.zyData=data;
    return;
  }else if(count>=0&&count<6&&!existFlag){
    // zyData[index].zyBtnTxt='专业'+(count+1);
    this.$set(this.zyData[index],'zyBtnTxt','专业'+(count+1));
  }else if(existFlag){
    zyData[index].zyBtnTxt='填报';
    schoolList[index2]['zy'+zyIndex]='';
    schoolList[index2]['zymc'+zyIndex]='';
  }
  if(!existFlag&&count>=0&&count<6){
    schoolObj['zy'+(count+1)]=obj.zydh||obj.zydm;
    schoolObj['zymc'+(count+1)]=obj.zymc;
  }else{
    // 1 2 3 4 5 6-> 1 3 4 5 6->1 2 3 4 5
    // 1 2 3 4 5 6-> 1 2 4 5 6->1 2 3 4 6
    // 1 2 3 4 5 6-> 1 2 3 5 6->1 2 3 4 5
    // 1 2 3 4 5 6-> 1 2 3 5 6->1 2 3 4 5
    // 6 5 4 3 2 1-> 6 5 3 2 1 ->1 2 3 5 6->1 2 3 4 5-> 5 4 3 2 1
    let haveZyCount=0;
    const oldZyIndexArr=[];
    let newZyIndexArr=[];
    const oldSortIndexArr=[];
    const haveZyIndexArr=[];
    const zyObjArr=[];
    const haveZydhArr=[];
    const haveZymcArr=[];
    const newZydhArr=[];
    const newZymcArr=[];
    const schoolZyNumChangeArr=[];
    const pageTotal=(zyData.length)/4;
    const oldZyIndexArr2=[];
    let newZyIndexArr2=[];
    const oldSortIndexArr2=[];
    const haveZyIndexArr2=[];
    const oldZyNumArr=[];
    let newZyNumArr=[];
    const oldSortZyNumArr=[];
    const haveZyNumArr=[];
    const zyObjArr2=[];
    let zyNumChangeArr=[];
    const newZyNumChangeArr=[];
    zyData[index].zyBtnTxt='填报';
    for(let i=1;i<pageTotal+1;i++){
      const obj=zyData[i*4-4];
      if(obj.zyBtnTxt.indexOf('专业')>=0){
        oldZyIndexArr2.push(i*4-4);
        const zyNum=parseInt(obj.zyBtnTxt.split("专业")[1]);
        oldZyNumArr.push(zyNum);
        const obj2={};
        obj2.zyNum=zyNum;
        obj2.zyNumIndex=i*4-4;
        zyObjArr2.push(obj2);
      }
    }
    newZyNumArr=[...oldZyNumArr];
    newZyNumArr.sort((a,b)=>{
      return a-b;
    });
    for(let i=0;i<oldZyNumArr.length;i++){
      if(newZyNumArr[i]>1){
        if(oldSortZyNumArr.indexOf(newZyNumArr[i]-1)<0){
          oldSortZyNumArr.push(newZyNumArr[i]-1);
        }else{
          oldSortZyNumArr.push(newZyNumArr[i]);
        }
      }else{
        oldSortZyNumArr.push(1);
      }
    }
    console.log(zyObjArr2,oldSortZyNumArr);
    zyNumChangeArr=[...zyObjArr2];
    zyNumChangeArr.sort((a,b)=>{
      return a.zyNum-b.zyNum;
    });
    for(let i=0;i<zyNumChangeArr.length;i++){
      if(zyNumChangeArr[i].zyNum>1){
        let flag=false;
        for(let j=0;j<newZyNumChangeArr.length;j++){
          if(zyNumChangeArr[i].zyNum-1===newZyNumChangeArr[j].zyNum){
            flag=true;
            break;
          }
        }
        if(!flag){
          const obj={};
          obj.zyNum=zyNumChangeArr[i].zyNum-1;
          obj.zyNumIndex=zyNumChangeArr[i].zyNumIndex;
          newZyNumChangeArr.push(obj);
        }else{
          newZyNumChangeArr.push(zyNumChangeArr[i]);
        }
      }else{
        newZyNumChangeArr.push(zyNumChangeArr[i]);
      }
    }
    for(let i=0;i<newZyNumChangeArr.length;i++){
      if(newZyNumChangeArr[i]){
        zyData[newZyNumChangeArr[i].zyNumIndex].zyBtnTxt='专业'+newZyNumChangeArr[i].zyNum;
      }
    }
    for(let i=1;i<7;i++){
      if(schoolList[index2]['zy'+i]){
        haveZyCount++;
        oldZyIndexArr.push(i);
        const obj={};
        obj.zyNumIndex=index2;
        obj.zyNum=i;
        obj.zydh=schoolList[index2]['zy'+i];
        obj.zymc=schoolList[index2]['zymc'+i];
        zyObjArr.push(obj);
      }
    }
    newZyIndexArr=[...oldZyIndexArr];
    newZyIndexArr.sort((a,b)=>{
      return a-b;
    });
    for(let i=0;i<newZyIndexArr.length;i++){
      if(newZyIndexArr[i]>1){
        if(oldSortIndexArr.indexOf(newZyIndexArr[i]-1)<0){
          oldSortIndexArr.push(newZyIndexArr[i]-1);
        }else{
          oldSortIndexArr.push(newZyIndexArr[i]);
        }
      }else{
        oldSortIndexArr.push(1);
      }
    }
    console.log(oldSortIndexArr,zyObjArr);
    for(let i=0;i<zyObjArr.length;i++){
      for(let j=0;j<oldSortIndexArr.length;j++){
        if(zyObjArr[i].zyNum>1){
          if(zyObjArr[i].zyNum-1===oldSortIndexArr[j]){
            let flag=false;
            for(let a=0;a<schoolZyNumChangeArr.length;a++){
              if(schoolZyNumChangeArr[a].zyNum===zyObjArr[i].zyNum-1){
                flag=true;
                break;
              }
            }
            if(!flag){
              const obj={};
              obj.zyNum=oldSortIndexArr[j];
              obj.zydh=zyObjArr[i].zydh;
              obj.zymc=zyObjArr[i].zymc;
              schoolZyNumChangeArr.push(obj);
            }else{
              schoolZyNumChangeArr.push(zyObjArr[i]);
            }
          }
        }else{
          let flag=false;
          for(let k=0;k<schoolZyNumChangeArr.length;k++){
            if(schoolZyNumChangeArr[k].zyNum===zyObjArr[i].zyNum){
              flag=true;
              break;
            }
          }
          if(!flag){
            schoolZyNumChangeArr.push(zyObjArr[i]);
          }
        }
      }
    }
    for(let i=1;i<7;i++){
      if(schoolList[index2]){
        schoolList[index2]['zy'+i]=''
        schoolList[index2]['zymc'+i]='';
      }
    }
    console.log(schoolZyNumChangeArr);
    for(let i=0;i<schoolZyNumChangeArr.length;i++){
      if(schoolZyNumChangeArr[i]){
        schoolList[index2]['zy'+schoolZyNumChangeArr[i].zyNum]=schoolZyNumChangeArr[i].zydh;
        schoolList[index2]['zymc'+schoolZyNumChangeArr[i].zyNum]=schoolZyNumChangeArr[i].zymc;
      }
    }
  }
  if(!schoolList[index2]||(schoolList[index2].yxmc!==item.yxmc)){
    schoolObj['zy'+(count+1)]=obj.zydh||obj.zydm;
    schoolObj['zymc'+(count+1)]=obj.zymc;
    schoolList.push(schoolObj);
  }else if(schoolList[index2]&&!existFlag&&schoolList[index2].yxmc===item.yxmc){
    schoolList[index2]['zy'+(count+1)]=obj.zydh||obj.zydm;
    schoolList[index2]['zymc'+(count+1)]=obj.zymc;
  }
  console.log(schoolList);
  // if(schoolList[index2].sfsc===0){
  //   await this.addCollect(schoolList[index2].zyz,schoolList[index2].sfsc);
  // }
  const res=await this.$http.postHttp("/yhgz/saveOrUpdateYhgzyxzyz",{
            yhid:this.userInfo.yhid,
            yxxh:schoolObj.yxxh,
            yxmc:schoolObj.yxmc,
            pc,
            kl:this.userInfo.sxkm,
            zyz:schoolObj.zyz,
            xm:this.userInfo.xm,
            fs:this.userInfo.gkfs+"",
            xh:"",
            gzsj:"",
            zydh1:schoolList[index2].zy1?schoolList[index2].zy1:'',
            zydh2:schoolList[index2].zy2?schoolList[index2].zy2:'',
            zydh3:schoolList[index2].zy3?schoolList[index2].zy3:'',
            zydh4:schoolList[index2].zy4?schoolList[index2].zy4:'',
            zydh5:schoolList[index2].zy5?schoolList[index2].zy5:'',
            zydh6:schoolList[index2].zy6?schoolList[index2].zy6:''
  });
  if(res.data.code===200){
    this.zyData=zyData;
    this.schoolList=schoolList;
    this.updateZyList=!this.updateZyList;
    await this.getZyzDetail(this.showYxObj.gbdm,zyz,pc,yxmc,yxxh,null,this.showYxObj);
    // this.$set(this.zyData[index],'isDisabled',false);
  
    const data=[...this.zyData];
    data.forEach((item)=>{
        item.isDisabled=false;
    });
    this.zyData=data;
  }else if(res.data.code===500){
            if(res.data.message){
                this.$message({message:res.data.message,type:'error'});
            }
  }else if(res.status===401){
            this.$message({message: '登录超时，请重新登录',type:"error"});
            await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
            this.$router.replace({
                path: '/main/home',
                query: {redirect: this.$router.currentRoute.fullPath}
            });
  }else if(res.data.code===0){
                this.$message({message:"您的账号在其他地点登陆了！",showClose:true,type:'warning'});
                await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
                this.$router.replace({
                    path: '/main/home',
                    query: {redirect: this.$router.currentRoute.fullPath}
                });
  }else if(res.status===409||res.status===410||res.status===411){
                this.$message({message:"您的账号在其他地点登陆了！",showClose:true,type:'warning'});
                await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
                this.$router.replace({
                    path: '/main/home',
                    query: {redirect: this.$router.currentRoute.fullPath}
                });
  }
},
addSchoolList2(obj,item){
const yxmc=item.yxmc||obj.yxmc||"";
const sb=item.sb||obj.sb||"";
const zyz=item.zyz||obj.zyz||"";
const pc=item.pc||obj.pc||0;
const sf985=item.sf985||obj.sf985||0;
const sf211=item.sf211||obj.sf211||0;
const sfsyl=item.sfsyl||obj.sfsyl||0;
const sfyjsy=item.sfyjsy||obj.sfyjsy||0;
const snjhrs=item.wnjhs||item.wnjhs||0;
const jnjhrs=item.jnjhs||obj.jnjhs||0;
let snrdwc=0;
let jnrdwc=0;
const subs=[...item.subs];
let nds=[];
for(let i=0;i<subs.length;i++){
  if(subs[i].nd>0){
    nds.push(subs[i].nd);
  }
}
nds=[...(new Set(nds))].sort(function(a,b){
return b-a;
});
let tdx=0;
let zdtwf=0;
let pjtwf=0;
let zgtwf=0;
const nd1=nds[0];
const nd2=nds[1];
for(let i=0;i<subs.length;i++){
  if(subs[i].nd===nd1){
    jnrdwc=subs[i].rdwc;
    tdx=subs[i].tdx;
    zdtwf=subs[i].zdtwf;
    zgtwf=subs[i].zgtwf;
    pjtwf=subs[i].pjtwf;
  }else if(subs[i].nd===nd2){
    snrdwc=subs[i].rdwc;
  }
}
const zyData=[...this.zyData];
let index=0;
for(let i=0;i<zyData.length;i++){
  if(zyData[i].zymc===obj.zymc){
    index=i;
    break;
  }
}
const schoolObj={};
schoolObj.yxmc=yxmc;
schoolObj.zyz=zyz;
schoolObj.sb=sb;
schoolObj.pc=pc;
schoolObj.sf985=sf985;
schoolObj.sf211=sf211;
schoolObj.snjhrs=snjhrs;
schoolObj.jnjhrs=jnjhrs;
schoolObj.snrdwc=snrdwc;
schoolObj.jnrdwc=jnrdwc;
schoolObj.tdx=tdx;
schoolObj.zdtwf=zdtwf;
schoolObj.pjtwf=pjtwf;
schoolObj.zgtwf=zgtwf;
const schoolList=[...this.schoolList];
let index2=0;
for(let i=0;i<schoolList.length;i++){
  if(schoolList[i].yxmc===item.yxmc){
    index2=i;
    break;
  }
}
let count=0;
let existFlag=false;
let zyIndex=0;
for(let i=1;i<7;i++){
  if(schoolList[index2]&&schoolList[index2]['zy'+i]){
    if((schoolList[index2]['zy'+i]===obj.zydh)
    ||(schoolList[index2]['zy'+i]===obj.zydm)){
      existFlag=true;
      zyIndex=i;
    }
    count++;
  }
}
if(count===6&&!existFlag){
  this.$message({message:'每个志愿最多填报6个专业'});
    if(addType==='1'){
        const data=[...this.zyData];
        data.forEach((item)=>{
            item.isDisabled=false;
        });
        this.zyData=data;
    }else{
        const data=[...this.zyData2];
        data.forEach((item)=>{
            item.isDisabled=false;
        });
        this.zyData2=data;
    }
  return;
}else if(count>=0&&count<6){
  // zyData[index].zyBtnTxt='专业'+(count+1);
  this.$set(this.zyData[index],'zyBtnTxt','专业'+(count+1));
}else if(existFlag){
  zyData[index].zyBtnTxt='填报';
  schoolList[index2]['zy'+zyIndex]='';
  schoolList[index2]['zymc'+zyIndex]='';
}
if(!existFlag&&count>=0&&count<6){
  schoolObj['zy'+(count+1)]=obj.zydh||obj.zydm;
  schoolObj['zymc'+(count+1)]=obj.zymc;
}else{
  // 1 2 3 4 5 6-> 1 3 4 5 6->1 2 3 4 5
  // 1 2 3 4 5 6-> 1 2 4 5 6->1 2 3 4 6
  // 1 2 3 4 5 6-> 1 2 3 5 6->1 2 3 4 5
  // 1 2 3 4 5 6-> 1 2 3 5 6->1 2 3 4 5
  // 6 5 4 3 2 1-> 6 5 3 2 1 ->1 2 3 5 6->1 2 3 4 5-> 5 4 3 2 1
  let haveZyCount=0;
  const oldZyIndexArr=[];
  let newZyIndexArr=[];
  const oldSortIndexArr=[];
  const haveZyIndexArr=[];
  const zyObjArr=[];
  const haveZydhArr=[];
  const haveZymcArr=[];
  const newZydhArr=[];
  const newZymcArr=[];
  const schoolZyNumChangeArr=[];
  const pageTotal=(zyData.length)/4;
  const oldZyIndexArr2=[];
  let newZyIndexArr2=[];
  const oldSortIndexArr2=[];
  const haveZyIndexArr2=[];
  const oldZyNumArr=[];
  let newZyNumArr=[];
  const oldSortZyNumArr=[];
  const haveZyNumArr=[];
  const zyObjArr2=[];
  let zyNumChangeArr=[];
  const newZyNumChangeArr=[];
  zyData[index].zyBtnTxt='填报';
  for(let i=1;i<pageTotal+1;i++){
    const obj=zyData[i*4-4];
    if(obj.zyBtnTxt.indexOf('专业')>=0){
      oldZyIndexArr2.push(i*4-4);
      const zyNum=parseInt(obj.zyBtnTxt.split("专业")[1]);
      oldZyNumArr.push(zyNum);
      const obj2={};
      obj2.zyNum=zyNum;
      obj2.zyNumIndex=i*4-4;
      zyObjArr2.push(obj2);
    }
  }
  newZyNumArr=[...oldZyNumArr];
  newZyNumArr.sort((a,b)=>{
    return a-b;
  });
  for(let i=0;i<oldZyNumArr.length;i++){
    if(newZyNumArr[i]>1){
      if(oldSortZyNumArr.indexOf(newZyNumArr[i]-1)<0){
        oldSortZyNumArr.push(newZyNumArr[i]-1);
      }else{
        oldSortZyNumArr.push(newZyNumArr[i]);
      }
    }else{
      oldSortZyNumArr.push(1);
    }
  }
  console.log(zyObjArr2,oldSortZyNumArr);
  zyNumChangeArr=[...zyObjArr2];
  zyNumChangeArr.sort((a,b)=>{
    return a.zyNum-b.zyNum;
  });
  for(let i=0;i<zyNumChangeArr.length;i++){
    if(zyNumChangeArr[i].zyNum>1){
      let flag=false;
      for(let j=0;j<newZyNumChangeArr.length;j++){
        if(zyNumChangeArr[i].zyNum-1===newZyNumChangeArr[j].zyNum){
          flag=true;
          break;
        }
      }
      if(!flag){
        const obj={};
        obj.zyNum=zyNumChangeArr[i].zyNum-1;
        obj.zyNumIndex=zyNumChangeArr[i].zyNumIndex;
        newZyNumChangeArr.push(obj);
      }else{
        newZyNumChangeArr.push(zyNumChangeArr[i]);
      }
    }else{
      newZyNumChangeArr.push(zyNumChangeArr[i]);
    }
  }
  for(let i=0;i<newZyNumChangeArr.length;i++){
    if(newZyNumChangeArr[i]){
      zyData[newZyNumChangeArr[i].zyNumIndex].zyBtnTxt='专业'+newZyNumChangeArr[i].zyNum;
    }
  }
  for(let i=1;i<7;i++){
    if(schoolList[index2]['zy'+i]){
      haveZyCount++;
      oldZyIndexArr.push(i);
      const obj={};
      obj.zyNumIndex=index2;
      obj.zyNum=i;
      obj.zydh=schoolList[index2]['zy'+i];
      obj.zymc=schoolList[index2]['zymc'+i];
      zyObjArr.push(obj);
    }
  }
  newZyIndexArr=[...oldZyIndexArr];
  newZyIndexArr.sort((a,b)=>{
    return a-b;
  });
  for(let i=0;i<newZyIndexArr.length;i++){
    if(newZyIndexArr[i]>1){
      if(oldSortIndexArr.indexOf(newZyIndexArr[i]-1)<0){
        oldSortIndexArr.push(newZyIndexArr[i]-1);
      }else{
        oldSortIndexArr.push(newZyIndexArr[i]);
      }
    }else{
      oldSortIndexArr.push(1);
    }
  }
  console.log(oldSortIndexArr,zyObjArr);
  for(let i=0;i<zyObjArr.length;i++){
    for(let j=0;j<oldSortIndexArr.length;j++){
      if(zyObjArr[i].zyNum>1){
        if(zyObjArr[i].zyNum-1===oldSortIndexArr[j]){
          let flag=false;
          for(let a=0;a<schoolZyNumChangeArr.length;a++){
            if(schoolZyNumChangeArr[a].zyNum===zyObjArr[i].zyNum-1){
              flag=true;
              break;
            }
          }
          if(!flag){
            const obj={};
            obj.zyNum=oldSortIndexArr[j];
            obj.zydh=zyObjArr[i].zydh;
            obj.zymc=zyObjArr[i].zymc;
            schoolZyNumChangeArr.push(obj);
          }else{
            schoolZyNumChangeArr.push(zyObjArr[i]);
          }
        }
      }else{
        let flag=false;
        for(let k=0;k<schoolZyNumChangeArr.length;k++){
          if(schoolZyNumChangeArr[k].zyNum===zyObjArr[i].zyNum){
            flag=true;
            break;
          }
        }
        if(!flag){
          schoolZyNumChangeArr.push(zyObjArr[i]);
        }
      }
    }
  }
  for(let i=1;i<7;i++){
    if(schoolList[index2]){
      schoolList[index2]['zy'+i]=''
      schoolList[index2]['zymc'+i]='';
    }
  }
  console.log(schoolZyNumChangeArr);
  for(let i=0;i<schoolZyNumChangeArr.length;i++){
    if(schoolZyNumChangeArr[i]){
      schoolList[index2]['zy'+schoolZyNumChangeArr[i].zyNum]=schoolZyNumChangeArr[i].zydh;
      schoolList[index2]['zymc'+schoolZyNumChangeArr[i].zyNum]=schoolZyNumChangeArr[i].zymc;
    }
  }
}
if(!schoolList[index2]){
  schoolObj['zy'+(count+1)]=obj.zydh||obj.zydm;
  schoolObj['zymc'+(count+1)]=obj.zymc;
  schoolList.push(schoolObj);
}else if(schoolList[index2]&&!existFlag){
  schoolList[index2]['zy'+(count+1)]=obj.zydh||obj.zydm;
  schoolList[index2]['zymc'+(count+1)]=obj.zymc;
}
console.log(schoolList);
this.zyData=zyData;
this.schoolList=schoolList;
this.updateZyList=!this.updateZyList;
},
openTianBaoList(){
  this.dialogListVisible=true;
},
async handleClose(done){
  const schoolList=[...this.schoolList];
  if(schoolList.length>0){
      const isConfirm=await this.$confirm("志愿表还未保存，是否保存").catch(err=>err);
      console.log(isConfirm);
      if(isConfirm==='confirm'){
        done();
      }else{
        this.schoolList=[];
        done();
      }
  }else{
    done();
  }
},
    // 关注院校
async addCollect(zyz,status){
        const loading=this.$loading({fullscreen:true,target:document.body,text:"正在加载中"});
        const { pc,yxxh } = {...this.showYxObj};
        this.collectLoading=true;
        const res=await this.$http.postHttp("/yhgz/addGzYxZyz",{
            yhid:this.userInfo.yhid,
            yxxh,
            pc,
            kl:this.userInfo.sxkm,
            zyz,
            xm:this.userInfo.xm,
            fs:this.userInfo.gkfs+"",
            xh:"",
            status,
            gzsj:""
        });
        if(res.data.code===200){
            // await this.getYxzyz();
            const num=res.data.obj;
          if(res.data.message){
            const msg=res.data.message+'，共收藏 '+num+' 所院校专业组';
            this.$message({type:"success",message:msg,showClose:true});
            await this.getZyzDetail(this.showYxObj.gbdm,zyz,pc,this.showYxObj.yxmc,yxxh,null,this.showYxObj);
          }else{
            const msg='操作成功'+'，共收藏 '+num+' 所院校专业组';
            this.$message({type:"success",message:msg,showClose:true});
            await this.getZyzDetail(this.showYxObj.gbdm,zyz,pc,this.showYxObj.yxmc,yxxh,null,this.showYxObj);
          }
        }else if(res.data.code===500){
            this.$message({message:res.data.message,type:"error"});
        }else if(res.status===401){
            this.$message({message: '登录超时，请重新登录',type:"error"});
            await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
            this.$router.replace({
                path: '/main/home',
                query: {redirect: this.$router.currentRoute.fullPath}
            });
        }else if(res.data.code===0){
            this.$message({message:"您的账号在其他地点登陆了！",showClose:true,type:'warning'});
            await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
            this.$router.replace({
                path: '/main/home',
                query: {redirect: this.$router.currentRoute.fullPath}
            });
        }else if(res.status===409||res.status===410||res.status===411){
            this.$message({message:"您的账号在其他地点登陆了！",showClose:true,type:"warning"});
            await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
            this.$router.replace({
                path: '/main/home',
                query: {redirect: this.$router.currentRoute.fullPath}
            });
        }
        // const type=this.type;
        // if(type==="1"){
        //     const list=this.zyzTotals.list;
        //     for(let i=0;i<list.length;i++){
        //         if(list[i].zyz===zyz){
        //             const isSc=list[i].isSc;
        //             if(isSc===0){
        //                 list[i].isSc=1;
        //             }else{
        //                 list[i].isSc=0;
        //             }
        //         }
        //     }
        // }else if(type==="2"){
        //     const isSc=this.isSc;
        //     if(isSc===0){
        //         this.isSc=1;
        //     }else{
        //         this.isSc=0;
        //     }
        // }
        // this.$forceUpdate();
        this.collectLoading=false;
        // const type=this.type;
        // if(type==="1"){
        //     await this.getSchoolDeatil();
        // }else if(type==="2"){
        //     await this.getZyzDeatil();
        // }
        // this.$forceUpdate();
        loading.close();
},
deleteYxdb(index){
let arr2=[...this.compareSchool];
arr2.splice(index,1);
this.$store.dispatch("saveCompareSchool",{compareSchool:arr2});
  const recommendList=[...this.recommendData.data.list];
  const compares=this.compareSchool;
  for(let i=0;i<recommendList.length;i++){
    recommendList[i].isShowCompare=false;
  }
  const arr=[];
  for(let i=0;i<recommendList.length;i++){
    for(let j=0;j<compares.length;j++){
      if(compares[j].yxmc===recommendList[i].yxmc){
        recommendList[i].isShowCompare=true;
        arr.push(i);
      }
    }
  }
  this.currentArr=[...arr];
  this.$store.commit("getRecommend",{recommendData:{data:{list:recommendList,total:this.recommendData.data.total,pageSize:this.recommendData.data.pageSize,pageNum:this.recommendData.data.pageNum}}});
},
// 跨行
objectSpanMethod({row, column, rowIndex, columnIndex }){
        if(columnIndex===0||columnIndex===1||columnIndex===11||columnIndex===12){
            if(rowIndex%4===0){
                return{
                    rowspan:4,
                    colspan:1
                };
            }else {
                return {
                    rowspan:0,
                    colspan:0
                };
            }
        }
},
},
mounted(){
this.yxdbCode();
this.initYxdb();
  const recommendList=[...this.recommendData.data.list];
  const compares=this.compareSchool;
  for(let i=0;i<recommendList.length;i++){
    recommendList[i].isShowCompare=false;
  }
  const arr=[];
  for(let i=0;i<recommendList.length;i++){
    for(let j=0;j<compares.length;j++){
      if(compares[j].yxmc===recommendList[i].yxmc){
        recommendList[i].isShowCompare=true;
        arr.push(i);
      }
    }
  }
  this.currentArr=[...arr];
  this.$store.commit("getRecommend",{recommendData:{data:{list:recommendList,total:this.recommendData.data.total,pageSize:this.recommendData.data.pageSize,pageNum:this.recommendData.data.pageNum}}});
},
watch:{
$route(to,from){
  if(
    (to.path === "/main/schoolRecommend" || to.path === "/main/schoolfinder") &&
      (from.path === "/main/schoolRecommend" || from.path === "/main/schoolfinder"||
      from.path==="/main/majorquery"||from.path==="/main/zypg"||from.path==="/main/datahome"||
      from.path==="/main/me/updateScore"||from.path==="/main/me/updatePwd"||from.path==="/main/buyindex")
      ){
        this.$store.commit("initRecommend");
        this.$store.commit("initCompareSchool");
        // this.yxdbCode();
        // this.initYxdb();
      }
}
},
computed:{
  ...mapState(["recommendData","userInfo","compareSchool"])
}
};
</script>
<style lang="less" scoped>
.school-data-wrap{
  width: 1100px;
  margin: 0 auto;
  padding: 0 30px 15px;
  box-sizing: border-box;
  background-color: #fff;
  .school-info{
    display: flex;
    padding: 20px 0;
    border-bottom: 1px solid #e4e7ed;
    flex-wrap: wrap;
    .info-logo{
      width: 100px;
      height: 100px;
    }
    .info-introduce{
      width: 940px;
      padding-left: 20px;
      box-sizing: border-box;
      .school-name{
        display: flex;
        align-items: center;
        font-size: 20px;
        color: #303133;
      }
      .school-category{
        width: 920px;
        display: flex;
        font-size: 14px;
        .category-wrap{
          // width: 35%;
          width: 30%;
          color: #666;
          .top-position{
            margin-top: 20px;
          }
          .category-item{
            display: inline-block;
            // width: 150px;
            width: 136px;
            margin-bottom: 10px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
          }
          .deleteSchool{
            width: 100px;
            height: 30px;
            font-size: 14px;
            border: 1px solid #2186de;
            border-radius: 5px;
            color: #2186de;
            background-color: #fff;
            outline: none;
            cursor: pointer;
          }
          .addSchool{
            width: 100px;
            height: 30px;
            font-size: 14px;
            border: 1px solid #f90;
            border-radius: 5px;
            color: #f90;
            background-color: #fff;
            outline: none;
            cursor: pointer;
          }
        }
        .info-data-wrap{
          // width: 65%;
          width: 70%;
          .info-data{
            width: 100%;
            color: #666;
            th{
              border: 1px solid #09f;
              padding: 1px 0;
              text-align: center;
              background-color: #e4f5ff;
            }
            td{
              padding: 1px 5px;
              border: 1px solid #09f;
              text-align: center;
            }
          }
        }
      }
    }
  }
}
.compareLayout {
  height: 220px;
  width: 984px;
  position: fixed;
  bottom: 0;
  left: 50%;
  margin-left: -492px;
  z-index: 9999;
  .hd{
    padding-top: 3px;
  }
  .tab{
    border: 1px solid #9F9999;
    border-left: 0;
    border-bottom: 0;
    height: 32px;
    padding-left: 1px;
    background-color: #FFF;
    li.current{
      color: #e86f1e;
      font-weight: bold;
      border: 2px solid #006bcf;
      border-bottom: 0;
      margin-top: -3px;
      position: relative;
      background-color: #FFF;
      line-height: 35px;
    }
    li{
      float: left;
      padding: 0 30px;
      line-height: 32px;
      cursor: pointer;
      font-size: 15px;
      color: #555;
      border-right: 1px solid #9F9999;
      border-left: 1px solid #9F9999;
      margin-left: -1px;
    }
  }
  a{
    color: #005AA0;
  }
  .bd{
    border: 2px solid #006bcf;
    height: 180px;
    background-color: #FFF;
  }
  .list{
    padding: 10px 13px;
    height: 160px;
    display: none;
    li{
      float: left;
      width: 16.5%;
      text-align: center;
    }
    .box{
      border-right: 1px dashed #D4D4D4;
      height: 140px;
      padding-top: 8px;
    }
    #compare_tool
    {
      .box {
      padding-top: 0px;
      }
    }
    .btnDisabled {
      width: 130px;
      // height: 32px;
      height: 62px;
      line-height: 32px;
      margin: 8px auto 5px;
      display: block;
      // border: 1px solid #E5E5E5;
      border: 1px solid black;
      // color: #999;
      color: blue;
      font-size: 18px;
      border-radius: 5px;
      cursor: default;
  }
  .btn{
    width: 130px;
    height: 34px;
    line-height: 34px;
    margin: 8px auto 10px;
    display: block;
    background-color: #2186de;
    color: #FFF;
  }
  }
  .close{
    position: absolute;
    right: 10px;
    top: 10px;
  }
}
.btnBt {
  display: inline-block;
  margin-top: 15px;
  font-size: 16px;
  color: #606266;
  padding: 5px 10px;
  border-radius: 4px;
  border: 1px solid #DCDFE6;
}
.btnBt.current {
  color: #fff;
  background-color: #2186de;
}
.yuceTdx{
  color: #ED4A09;
}
/deep/ .el-table .yuceTdx{
    color: #ED4A09 !important;
}
#zyData{
    // width: 790px;
    // margin: 0 auto;
}
.school-detail-wraper{
    min-width:1100px;
    margin:0 auto;
    min-height:calc(100vh - 380px);
    min-height:-moz-calc(100vh - 380px);
    min-height:-webkit-calc(100vh - 380px);
    .card-top{
        width: 1100px;
        margin: 20px auto;
    }
    .detail-top{
        display: flex;
        align-items: center;
        width: 1100px;
        margin: 0 auto;
        padding: 20px 0;
        background-color: #fff;
        .top-logo{
            width: 80px;
            height: 80px;
            box-sizing: border-box;
            margin: 0 30px;
        }
        .top-mid{
            width: 80%;
            box-sizing: border-box;
            color: #666;
        }
        .mid-school-name{
            display: flex;
            justify-content: space-between;
            margin-bottom: 10px;
            font-size: 18px;
            color: #333;
        }
        .mid-school-nature{
            display: flex;
            font-size: 14px;
            .nature-item{
                flex: 1;
                .school-link{
                    cursor: pointer;
                }
            }
        }
    }
    .detail-main{
        box-sizing: border-box;
        width: 1100px;
        margin: 0 auto;
        padding: 20px 30px;
        background-color: #fff;
    }
}
.schoolIntro_con2 {
    // width: 890px;
    width: 990px;
    padding-top: 0;
    overflow: hidden;
    // margin: 0 20px 50px 190px;
    min-height: 500px;
    margin-left:15px;
    // padding-top: 130px;
}
.catTitle2 {
    height: 35px;
    border-left: 5px solid #5287c6;
    padding-left: 20px;
    margin-bottom: 20px;
    margin-top: 20px;
    h2{
        font-size: 26px;
        line-height: 35px;
        font-weight: normal;
        color: #333;
    }
}
.info-data{
    width: 100%;
    color: #666;
    th{
        border: 1px solid #09f;
        padding: 1px 0;
        text-align: center;
        background-color: #e4f5ff;
    }
    td{
        padding: 1px 5px;
        border: 1px solid #09f;
        text-align: center;
    }
}
.schoolIntro_con {
    // margin: 30px 0 30px 180px;
    min-height: 500px;
    width: 510px;
    float: left;
    display: inline;
    .intro{
        text-align: justify;
        word-wrap: break-word;
        margin-bottom: 15px;
    }
    .txt{
        text-align: justify;
        word-wrap: break-word;
        margin-bottom: 35px;
    }
    a{
        color: #2186de;
    }
}
.baseInfo{
    border-top: 2px solid #efaf49;
    // background: url(school.css);
    line-height: 33px;
    margin-bottom: 20px;
    height: 170px;
    li{
        height: 33px;
        vertical-align: top;
    }
    .t{
        float: left;
      }
      .c{
        float: right;
        text-align: right;
        color: #999;
      }
}
.clearfix {
    *zoom: 1;
}
.baseInfo_left {
    float: left;
    width: 47%;
}
.baseInfo_right {
    float: right;
    width: 47%;
}
.catTitle {
    height: 35px;
    border-left: 5px solid #efaf49;
    padding-left: 20px;
    margin-bottom: 10px;
    h2{
        font-size: 26px;
        line-height: 35px;
        font-weight: normal;
        color: #efaf49;
        text-align: left;
    }
}
.schoolIntro_side {
    float: right;
    width: 260px;
    margin-top: 30px;
    .infos{
        border: 1px solid #E5E5E5;
        border-top: 0;
        ul{
            padding: 5px 12px 12px 12px;
        }
        li{
            padding: 10px 0 10px 75px;
            border-bottom: 1px dashed #DDD;
            line-height: 18px;
            word-wrap: break-word;
            overflow: hidden;
        }
        label{
            float: left;
            margin-left: -75px;
        }
        .website{
            height: 30px;
            margin-left: 15px;
            margin-bottom: 10px;
            a{
                line-height: 28px;
                float: left;
                border: 1px solid #D6D6D6;
                border-radius: 5px;
                text-align: center;
            }
            .a1{
                width: 90px;
                margin-right: 13px;
            }
            .a2{
                width: 120px;
            }
        }
    }
}
.schoolIntro_sideBd {
    width: 260px;
}
.schoolPic_slide {
    width: 260px;
    height: 240px;
    overflow: hidden;
    position: relative;
    ul{
        width: 260px;
        height: 240px;
        overflow: hidden;
    }
    li{
        float: left;
    }
    img{
        width: 260px;
        height: 240px;
    }
}
.collectBtn{
    width: 36px;
    padding: 3px;
    margin: 0 auto;
    font-size: 13px;
    color: #fff;
    border: 1px solid #f17070;
    border-radius: 3px;
    background: #f17070;
    cursor: pointer;
}
.schoolIntro_con22 {
    width: 790px;
    padding-top: 0;
    overflow: hidden;
    margin-left:15px;
    .majorCon2 {
    height: 35px;
    border-left: 5px solid #efaf49;
    padding-left: 20px;
    padding-bottom: 5px;
    margin-bottom: 10px;
    border-bottom: 1px solid #efaf49;
    clear: left;
}
h3{
    font-size: 26px;
    line-height: 35px;
    font-weight: normal;
    color: #efaf49;
}
.majorCon1 {
    margin-bottom: 25px;
    .list{
        margin-bottom: 15px;
    // background: url(school.css);
    li{
        // background: url(school.css) no-repeat 28px 20px;
        text-indent: 18px;
        height: 45px;
        line-height: 45px;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        float: left;
        width: 235px;
        padding-left: 15px;
        list-style: square;
    }
    }
}
}
.schoolIntro_con23 {
    width: 790px;
    padding-top: 0;
    overflow: hidden;
    margin-left:15px;
    .majorCon2 {
    height: 35px;
    border-left: 5px solid #efaf49;
    padding-left: 20px;
    padding-bottom: 5px;
    margin-bottom: 10px;
    border-bottom: 1px solid #efaf49;
    clear: left;
    h3{
        font-size: 26px;
    line-height: 35px;
    font-weight: normal;
    color: #efaf49;
    }
}
.txt{
    margin-bottom: 20px;
}
}
.yuceTdx{
    color: #ED4A09;
}
.yx_zy_group {
    box-sizing: border-box;
    border: 1px solid #eaeaea;
    border-bottom: none;
    border-radius: 5px 5px 0 0;
}
.group_title {
    display: -webkit-box;
    display: -ms-flexbox;
    display: -webkit-flex;
    display: flex;
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between;
    -webkit-justify-content: space-between;
    align-items: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    -webkit-align-items: center;
    padding: 5px;
    font-size: 18px;
    font-weight: 600;
    color: #fefefe;
    background: rgb(38, 190, 228);
    .collect{
        padding: 3px 10px;
        font-size: 14px;
        color: #fff;
        border: 1px solid #f17070;
        border-radius: 3px;
        background: #f17070;
        cursor: pointer;
    }
}
.group_content {
    padding: 10px 0 10px;
    border-bottom: 1px solid #eaeaea;
    .zy_name {
    width: 96%;
    padding-left: 15px;
    font-size: 16px;
    color: #303133;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    .index{
        display: inline-block;
        padding: 0 6px;
        background-color: #5bc3ef33;
    }
    .tip{
        font-size: 14px;
        color: #606266;
    }
}
.zy_attrs {
    display: -webkit-box;
    display: -ms-flexbox;
    display: -webkit-flex;
    display: flex;
    margin: 10px 0 0;
    .attr-item:first-child {
    margin-left: 40px;
    }
    .attr-item {
    margin-right: 20px;
    padding: 0 10px;
    border-radius: 3px;
    font-size: 12px;
    color: #ff6900;
    background-color: #ff690021;
}
}
}
.seMangSeRuo{
    // font-size: 14px;
    // color: #606266;
    color: red;
}
h1,h2,h3,h4,h5,h6{
    margin: 0 !important;
    font-weight: 700 !important;
}
*{
  box-sizing: content-box;
}
</style>
